import {
    GENERATEMERCHANTWIRELIST_SUCCESS,
    GENERATEMERCHANTWIRELIST_FAILED,
    RESET_GENERATEMERCHANTWIRELIST,
    LOADING_GENERATEMERCHANTWIRELIST,
    NETWORK_ERROR_GENERATEMERCHANTWIRELIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GENERATEMERCHANTWIRELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GENERATEMERCHANTWIRELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GENERATEMERCHANTWIRELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GENERATEMERCHANTWIRELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GENERATEMERCHANTWIRELIST:
            return (state = initialState);
        default:
            return state;
    }
};
